
import { defineComponent, nextTick, onMounted } from 'vue';

export default defineComponent({
    name: "OnlyOfficeView",
    setup(props, { slots, expose, emit }) {
    }
});

onMounted(()=>{
})
